export function isExternalLink ( url: string | null ) {
  return url?.startsWith( "http://" ) || url?.startsWith( "https://" ) || false;
}
